import { css } from '@emotion/css';
import {
  Spacing,
  AlignItems,
  JustifyContent,
  ScreenBreakpoint,
  Display,
  Color,
  Font,
  FontWeight,
  TextAlign,
  AlignSelf,
  BaseStyle,
  FlexDirection,
} from 'src/styles';

export const container = css`
  background-color: #ffffff;
  ${Spacing.mb32}
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.my0}
    ${Spacing.mxAuto}
    width: 90%;
  }
`;

/** Mobile padding for a copy column. Width comes from the Ant Design Col. */
const copyColumn = css`
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    word-wrap: break-word;
    ${Spacing.p4}
  }
`;

/** Centered on every screen size. */
const centerCopy = css`
  ${copyColumn}

  && {
    ${TextAlign.center}
  }

  && * {
    text-align: inherit;
  }
`;

/** Centered from tablet up, left-aligned on mobile. */
const centerCopyLeftOnMobile = css`
  ${centerCopy}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    && {
      ${TextAlign.left}
    }
  }
`;

export const alignLeft = css`
  && {
    ${TextAlign.left}
  }

  && * {
    text-align: inherit;
  }
`;

export const main = css`
  width: 100%;
  min-width: 0;
`;

export const logoContainer = css`
  width: 100%;
  min-width: 0;

  a {
    ${Display.block}
    max-width: 100%;
    min-width: 0;
  }
`;

export const logoCol = css`
  max-width: 100%;
  min-width: 0;
`;

export const logo = css`
  ${Spacing.mt40}
  ${Spacing.mb24}
  ${Display.block}
  max-width: 100%;
  height: auto;
`;

/** My IPO mark on auth screens. Mobile matches the header logo. */
export const brandLogo = css`
  width: 200px;
  height: auto;

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    width: 132px;
  }
`;

export const title = centerCopy;

export const subtitle = css`
  ${centerCopy}
  ${Spacing.my0}
  ${Font.lg}
`;

export const afterSubtitle = css`
  ${centerCopyLeftOnMobile}
  ${Spacing.mt16}
  ${Spacing.mb40}
`;

export const footer = css`
  ${centerCopyLeftOnMobile}
  ${Spacing.my0}
  ${Font.lg}
  ${Spacing.mb40}
`;

export const cardContainer = css`
  ${Display.flex}
  ${FlexDirection.row}
  ${AlignItems.center}
  ${JustifyContent.center}


  @media (min-width: ${ScreenBreakpoint.largeDesktop.max}) {
    max-width: 50%;
    margin-left: 25%;
  }

  @media (max-width: ${ScreenBreakpoint.largeDesktop.max}) {
    max-width: 75%;
    margin-left: 12.5%;
  }

  @media (max-width: ${ScreenBreakpoint.desktop.max}) {
    max-width: 100%;
    margin-left: 0;
  }

  @media (max-width: ${ScreenBreakpoint.laptop.max}) {
    max-width: 90%;
    margin-left: 5%;
  }

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    max-width: 100%;
    margin-left: 0;
    ${Spacing.mb32}
  }
`;

export const card = css`
  margin-left: 20%;
  width: 60%;

  @media (max-width: ${ScreenBreakpoint.laptop.max}) {
    width: 100%;
    margin: 0;
  }
`;

export const rightSlot = css`
  width: 18%;
  margin-left: 2%;
`;

export const cardContentContainer = css`
  width: 100%;
  ${Spacing.p20}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${AlignSelf.center}
  }
`;

export const cardTitle = css`
  ${FontWeight.semibold}
  ${Font.h4}
  ${Spacing.mb16}
  color: ${Color.Gray10};
  ${BaseStyle.level}
`;

export const cardSubtitle = css`
  ${Spacing.my0}
  ${Spacing.mxAuto}
  ${Font.lg}
  ${Spacing.mb40}
  ${TextAlign.center}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    word-wrap: break-word;
    ${Spacing.p4}
    width: 100%;
    ${TextAlign.left}
  }
`;

export const tabs = css`
  margin: auto;
  ${Spacing.my16}
  ${Display.table}
  width: 28rem;
  table-layout: fixed;
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    width: 100%;
  }
`;

export const tab = css`
  ${Display.tableCell}
  ${TextAlign.center}
  ${Font.lg}
  color: ${Color.Gray7};
  mix-blend-mode: normal;
`;

export const activeTab = css`
  ${FontWeight.bold}
  ${Font.lg}
  ${Display.tableCell}
  ${TextAlign.center}
  color: ${Color.Brand6};
  mix-blend-mode: normal;
`;
